import { type Dispatch, type MouseEvent, type SetStateAction, useEffect, useState } from 'react'

import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { Icon } from 'components'
import type { SapModalTypes } from 'container/ManageOVDetails/components/SapModal'
import { getOvStatusOptionsToSap, type OvDataToSap } from 'container/ManageOVDetails/utils'
import type { OVsByFilters } from 'services/manage_ov/interface'
import type { SapOptionsToOvStatus } from 'store/OVContext/ovContextTypes'
import { useSelector } from 'store/store'
import { theme } from 'styles/theme/hav-theme'

import * as S from './styles'

type ContextMenuProps = {
  setCurrentModal: Dispatch<SetStateAction<SapModalTypes | undefined>>
  setOvsSapData: Dispatch<SetStateAction<SapOptionsToOvStatus>>
  ovData: OVsByFilters
}

const OvMenu = ({ setCurrentModal, ovData, setOvsSapData }: ContextMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const { checkedOvs } = useSelector((state) => state.salesOrder)
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const [isMenuDisabled, setIsMenuDisabled] = useState(true)
  const [menuOptions, setMenuOptions] = useState<SapOptionsToOvStatus>({} as SapOptionsToOvStatus)

  const ovDataToSap: OvDataToSap[] = [
    {
      changeDate: ovData.DataAlteracao,
      number: ovData.NumeroOrdemVenda,
      statusKey: ovData.StatusOrdemVenda,
    },
  ]

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSapModal = (ovOptions: SapOptionsToOvStatus, modal: SapModalTypes): void => {
    setOvsSapData(ovOptions)
    setCurrentModal(modal)
    handleClose()
  }

  useEffect(() => {
    setMenuOptions(getOvStatusOptionsToSap(ovDataToSap))
  }, [ovData])

  useEffect(() => {
    const noActionAllowed =
      !menuOptions.isValidToReturnFromSap &&
      !menuOptions.isValidToSendToSap &&
      !menuOptions.isValidToReturnToSalesArea
    if (checkedOvs.length > 1 || noActionAllowed) {
      setIsMenuDisabled(true)
    } else {
      setIsMenuDisabled(false)
    }
  }, [checkedOvs, menuOptions])

  return (
    <>
      <S.ButtonStyled
        aria-controls={open ? 'basic-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        disabled={isMenuDisabled}
        id="basic-button"
        onClick={handleClick}
      >
        <Icon
          color={isMenuDisabled ? theme.colors.neutral.lighthover : theme.colors.primary.main}
          icon="ellipsis"
          size="15"
        />
      </S.ButtonStyled>
      <Menu
        anchorEl={anchorEl}
        id="basic-menu"
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        onClose={handleClose}
        open={open}
      >
        {menuOptions.isValidToSendToSap && (
          <MenuItem onClick={() => handleSapModal(menuOptions, 'sendModal')}>
            Enviar ao SAP
          </MenuItem>
        )}

        {menuOptions.isValidToReturnFromSap && (
          <MenuItem onClick={() => handleSapModal(menuOptions, 'returnModal')}>
            Retornar do SAP
          </MenuItem>
        )}

        {menuOptions.isValidToReturnToSalesArea && (
          <MenuItem onClick={() => handleSapModal(menuOptions, 'salesAreaModal')}>
            Devolver
          </MenuItem>
        )}
      </Menu>
    </>
  )
}

export default OvMenu
